import { Collapse, message } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getFaqs } from "../../../../../controller/services/settings";
import i18n from "../../../../../localization/i18n";
import { setLoading } from "../../../../../redux/slices/common_slice";
import RightSideSettingsWrapper from "../../rightside-details-settings/RightSideSettingsWrapper";

const { Panel } = Collapse;

const Faqs = () => {
  const [faqs, setFaqs] = useState([]);
  const dispatch = useDispatch();

  useEffect(() => {
    getFaqsList();
  }, []);

  const getFaqsList = () => {
    dispatch(setLoading(true));
    getFaqs()
      .then((resp) => {
        setFaqs(resp.data.faq);
      })
      .catch((Err) => {
        message.error(Err.message[i18n.language]);
      })
      .finally(() => {
        dispatch(setLoading(false));
      });
  };

  return (
    <RightSideSettingsWrapper>
      <div className="row faq-card-row">
        <div className="col-12">
          <Collapse
            defaultActiveKey={[faqs[1]?._id]}
            expandIcon={({ isActive }) => (
              <img
                src={`${
                  isActive
                    ? "/assets/images/icons/up-arrow-black.svg"
                    : "/assets/images/icons/down-arrow-balck.svg"
                }`}
                alt=""
                className="img-fluid"
              />
            )}
            accordion
          >
            {faqs.map((faq, index) => (
              <Panel header={faq?.question[i18n.language]} key={faq?._id}>
                {faq?.answer[i18n.language]}
              </Panel>
            ))}
          </Collapse>
        </div>
      </div>
    </RightSideSettingsWrapper>
  );
};

export default Faqs;
